var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageSpeakerSound = function SvgImageSpeakerSound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M21.392 8.346c.9 1.868 1.317 4.167 1.061 6.589a12.8 12.8 0 0 1-1.29 4.426l-2.146-1.01a10.4 10.4 0 0 0 1.08-3.664c.215-2.023-.156-3.949-.916-5.457zm4.382-1.745c1.185 2.587 1.73 5.633 1.392 8.836a17.4 17.4 0 0 1-1.73 5.934l-2.14-1.005a15 15 0 0 0 1.513-5.183c.297-2.807-.186-5.477-1.233-7.707zm4.394-1.755c1.47 3.287 2.127 7.104 1.707 11.084a21.9 21.9 0 0 1-2.15 7.457l-2.138-1.002a19.8 19.8 0 0 0 1.935-6.705c.38-3.595-.21-7.025-1.539-9.964zM16.711 0v26.736l-9.629-8.077H0V8.076h7.085z"
  })));
};
export { SvgImageSpeakerSound as ReactComponent };
export default __webpack_public_path__ + "assets/ImageSpeakerSound.e39455c8ecc124051fa86ee9b96fc620.svg";